import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { UniversityPickerComponent } from './university-picker/university-picker.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@NgModule({
    declarations: [],
    imports: [CommonModule, IonicModule, RouterModule, FormsModule, ReactiveFormsModule, MatTooltipModule, FontAwesomeModule,
UniversityPickerComponent],
    exports: [UniversityPickerComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class UniversityPickerComponentModule {}
